import { createFileRoute } from "@tanstack/react-router";
import { SDPConfigPage } from "../../../pages/sdp-config-page";

export const Route = createFileRoute("/_auth/_project/$projectId/$subProjectId/sdp-config")({
  component: SDPConfigPage,
});
